module.exports = __webpack_public_path__ + "img/index_ad.ec1b9ed5.png";